import { default as index0foi6xjaGPMeta } from "/home/runner/work/abdom-booking/abdom-booking/pages/index.vue?macro=true";
import { default as thank_45you_45one_45off6Dx09IfeQ3Meta } from "/home/runner/work/abdom-booking/abdom-booking/pages/thank-you-one-off.vue?macro=true";
import { default as thank_45you_45regularFDHbmXCXhSMeta } from "/home/runner/work/abdom-booking/abdom-booking/pages/thank-you-regular.vue?macro=true";
export default [
  {
    name: index0foi6xjaGPMeta?.name ?? "index",
    path: index0foi6xjaGPMeta?.path ?? "/",
    meta: index0foi6xjaGPMeta || {},
    alias: index0foi6xjaGPMeta?.alias || [],
    redirect: index0foi6xjaGPMeta?.redirect,
    component: () => import("/home/runner/work/abdom-booking/abdom-booking/pages/index.vue").then(m => m.default || m)
  },
  {
    name: thank_45you_45one_45off6Dx09IfeQ3Meta?.name ?? "thank-you-one-off",
    path: thank_45you_45one_45off6Dx09IfeQ3Meta?.path ?? "/thank-you-one-off",
    meta: thank_45you_45one_45off6Dx09IfeQ3Meta || {},
    alias: thank_45you_45one_45off6Dx09IfeQ3Meta?.alias || [],
    redirect: thank_45you_45one_45off6Dx09IfeQ3Meta?.redirect,
    component: () => import("/home/runner/work/abdom-booking/abdom-booking/pages/thank-you-one-off.vue").then(m => m.default || m)
  },
  {
    name: thank_45you_45regularFDHbmXCXhSMeta?.name ?? "thank-you-regular",
    path: thank_45you_45regularFDHbmXCXhSMeta?.path ?? "/thank-you-regular",
    meta: thank_45you_45regularFDHbmXCXhSMeta || {},
    alias: thank_45you_45regularFDHbmXCXhSMeta?.alias || [],
    redirect: thank_45you_45regularFDHbmXCXhSMeta?.redirect,
    component: () => import("/home/runner/work/abdom-booking/abdom-booking/pages/thank-you-regular.vue").then(m => m.default || m)
  }
]